.buttons {
  display: grid;
  grid-template-columns: 1fr 1fr;
}

.button {
  white-space: nowrap;
}
